<template>
  <div style="text-align: left;">
        <div style="width: 100%; text-align: right;">
            <el-button type="primary" size="small" @click="addTask">
                Add New Task
            </el-button>
        </div>
        <ul>
            <li 
                v-for="(data, index) in $store.getters.getTaskCalendarEventList"
                :key="index">
                    <a v-if="data.sales" href="javascript: void(0)" @click="openQuickView(data.id)" style="text-decoration: none; color: #000000;">
                        <span style="text-decoration: underline;">
                            {{data.sale_number}}, {{data.customer_name}}<br>
                        </span>                        
                        <span style="font-size: 12px;">
                            {{data.trial_required ? 'Trial Scheduled' : 'Delivery Scheduled'}}
                        </span> 
                    </a>
                    <a v-else-if="data.task" href="javascript: void(0)" @click="$store.dispatch('fetchTaskData', {id: data.id})" style="text-decoration: none; color: #000000;">
                        <span style="text-decoration: underline;">
                            {{data.title_prefix}}{{data.title}}<br>
                        </span>
                        <span style="font-size: 12px;">
                            {{data.task_type === 1 ? 'Appointment At '+data.task_time : ''}}
                        </span> 
                    </a>
                    
                    <div style="height: 10px;" v-html="'&nbsp;'"></div>
            </li>
        </ul>

        <el-dialog
            v-if="$store.state.tasks.show_task_form"
            :title="'New Task'"
            width="450px"
            :visible.sync="$store.state.tasks.show_task_form"
            append-to-body>
                <TaskForm 
                    @closed="$emit('loadCalendar')"/>
        </el-dialog>
        <el-dialog
            v-if="showQuickView"
            :width="'70%'"
            :visible.sync="showQuickView"
            append-to-body>
            <QuickDetail
                :calendar_source="true"
                :allow_delivery="false"
                :selected_date="selected_date"
                :store_id="store_id"
                :sale_id="selected_sale_id"
                @closed="showQuickView = false"/>
        </el-dialog>
  </div>
</template>

<script>
import TaskForm from '../../views/Tasks/TaskForm.vue'
import QuickDetail from '../../views/SaleMaster/QuickDetail/Index.vue'

export default {
    components: {TaskForm, QuickDetail},
    props: ['selected_date', 'store_id'],
    data() {
        return {
            showQuickView: false,
            selected_sale_id: 0
        }
    },
    computed: {
        isTaskFormVisible() {
            return this.$store.state.tasks.show_task_form
        }
    },
    methods: {
        addTask() {
            this.$store.commit('resetTaskData')
            this.$store.commit('resetTaskGroupData')   
            
            setTimeout(() => {
                this.$store.state.tasks.props.task_date = this.selected_date
                this.$store.state.tasks.props.task_time = this.selected_date+' 10:00:00'
                this.$store.state.tasks.show_task_form = true    
            }, 400);
        },
        openQuickView(saleId) {
          this.$store.commit('resetSaleMasterData')
          this.$store.commit('resetCustomerMasterData')
          this.selected_sale_id = saleId
          this.showQuickView = true
        }
    },
    mounted() {
        this.$store.state.tasks.show_task_form = false    
        this.$store.dispatch('loadAppointmentList', {selected_date: this.selected_date, store_id: this.store_id})
    },
    watch: {
        isTaskFormVisible(newValue) {
            if(!newValue) {
                this.$store.dispatch('loadAppointmentList', {selected_date: this.selected_date, store_id: this.store_id})
                this.$emit('loadCalendar')
            }            
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/TaskCalendar/Appointments.vue